import { useRuntime } from './RuntimeContext';
export function useService(name) {
    const runtime = useRuntime();
    return runtime.getService(name);
}
